import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints, custom }: Theme) => ({
  root: {
    paddingTop: 15,
  },
  btn: {
    minHeight: 'unset',
    marginBottom: 5,
    padding: 0,
    fontSize: 14,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  list: {
    margin: 0,
    paddingLeft: 10,
    [breakpoints.up('xs')]: {
      columns: 2,
    },
  },
  listItem: {
    paddingRight: 10,
    fontSize: 12,
    lineHeight: '20px',
    color: custom.grey[3],
  },
}));
